<template>
  <div class="ltl-list">
    <div class="e-form">
      <el-form
        label-position="top"
        :inline="true"
        ref="form"
        size="mini"
        :model="filter"
        @keypress.enter.native="searchLtl"
        class="flex-space"
      >
        <div>
          <el-form-item label="Hub">
            <el-select
              v-model="filter.hub_id_eq"
              filterable
              clearable
              @keyup.enter.native="searchLtls"
            >
              <el-option
                v-for="item in options.hubs"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Customer">
            <el-select
              v-model="filter.customers_id_eq"
              filterable
              clearable
              @keyup.enter.native="searchLtls"
              style="width: 250px"
            >
              <el-option
                v-for="item in options.customers"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Appt. Date">
            <el-date-picker
              ref="picker"
              size="mini"
              v-model="filter.appt_date_gteq"
              :clearable="true"
              format="MM/dd/yy"
              :value-format="'yyyy-MM-dd'"
              placeholder="From"
              style="width: 90px"
            >
            </el-date-picker>
            <el-date-picker
              ref="picker"
              size="mini"
              v-model="filter.appt_date_lteq"
              :clearable="true"
              format="MM/dd/yy"
              :value-format="'yyyy-MM-dd'"
              placeholder="To"
              style="width: 90px"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="Dispatched">
            <el-select
              v-model="filter.dispatched"
              filterable
              clearable
              style="width: 80px"
              @keyup.enter.native="searchLtls"
            >
              <el-option
                v-for="item in options.dispatchedStatuses"
                :key="item[1]"
                :label="item[0]"
                :value="item[1]"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label=" ">
            <el-checkbox v-model="filter.pending_operations"
              >Pending OPS</el-checkbox
            >
          </el-form-item>
          <el-form-item label=" ">
            <el-button type="primary" @click="searchLtls">Search</el-button>
          </el-form-item>
        </div>
        <div>
          <el-form-item label=" ">
            <popup
              componentPath="components/html"
              width="900px"
              :pivot-y="0"
              :options="{
                title: 'New LTL Order',
                url: `/ltl_containers/new?title_bar=false`,
              }"
            >
              <el-button>New LTL</el-button>
            </popup>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <LtlTable ref="table" :items="items" @loadMore="loadMore" />
  </div>
</template>
<script>
import LtlTable from "@/default/pages/ltls/table.vue";
export default {
  name: "LtlList",
  components: {
    LtlTable,
  },
  data() {
    return {
      filter: {
        dispatched: null,
        pending_operations: true,
      },
      infinite: {
        page: 1,
        loading: false,
        last: false,
      },
      items: [],
      options: {
        hubs: [],
        customers: [],
        dispatchedStatuses: [
          ["All", null],
          ["Yes", "true"],
          ["No", "false"],
        ],
      },
    };
  },
  mounted() {
    window.LtlList = {
      syncItem: this.syncItem,
      reload: this.loadLtls,
    };
  },
  created() {
    this.loadOptions();
    this.loadLtls();
  },
  methods: {
    loadOptions() {
      this.$http
        .get("/api/v1/hubs", { params: { category: "all" } })
        .then((response) => (this.options.hubs = response.data))
        .catch((err) => {});
      this.$http
        .get("/api/v1/options.json", { params: { target: "customers" } })
        .then((response) => (this.options.customers = response.data))
        .catch((err) => {});
    },
    searchLtls() {
      this.$refs.table.scrollTop();
      this.infinite.page = 1;
      this.infinite.last = false;
      this.items = [];
      this.loadLtls();
    },
    loadLtls() {
      this.infinite.loading = true;
      this.$http
        .get("/api/v1/ltls", {
          params: { q: this.filter, page: this.infinite.page },
        })
        .then((response) => {
          this.infinite.loading = false;
          const data = response.data;
          if (data.containers.length > 0) {
            const newItems = this.processItems(data.containers);
            this.items = this._.concat(this.items, newItems);
          } else {
            this.infinite.last = true;
          }
        })
        .catch((err) => {
          this.infinite.loading = false;
          this.$message({ message: err.response.data.errors, type: "error" });
        });
    },
    loadMore() {
      if (!this.infinite.loading && !this.infinite.last) {
        this.infinite.page += 1;
        this.loadLtls();
      }
    },
    processItems(items) {
      return items.map((item) => this.processItem(item));
    },
    processItem(item) {
      return item;
    },
    syncItem(data, action) {
      let index = this.items.findIndex((obj) => obj.id == data.id);
      if (index >= 0) {
        action == "deleted"
          ? this.items.splice(index, 1)
          : this.items.splice(index, 1, data);
      } else {
        this.items.unshift(data);
      }
    },
  },
};
</script>
